import { WorkSanctionDashboardWidgetStore } from './work-sanction-dashboard-widget.store';
import { Component, computed, inject, input } from '@angular/core';
import { getWorksFrag } from './work-sanction-dashboard-widget.query';
import {
    dateFromColumn,
    dateToColumn,
    folderPersonColumn,
    serviceField,
} from '../../../../../shared/components/kit/table/table.fields';
import { FilterBuilder } from '../../../../helper/filter.builder';
import { WorkTypeEnum } from '@libs/types/src/common/enum/work-type.enum';
import { TableColumnType } from '../../../../../shared/components/kit/table/table.types';
import { UserWidgetSetting } from '@libs/types/src/services/types/service-settings-user-widgets.type';
import { TableComponent } from '../../../../../shared/components/kit/table/table.component';

@Component({
    selector: 'app-work-sanction-dashboard-widget',
    templateUrl: './work-sanction-dashboard-widget.component.html',
    styleUrl: './work-sanction-dashboard-widget.component.scss',
    providers: [WorkSanctionDashboardWidgetStore],
    imports: [
        TableComponent,
    ],
})
export class WorkSanctionDashboardWidgetComponent {

    public readonly store = inject(WorkSanctionDashboardWidgetStore);

    items = input<{ serviceId: string, widget: UserWidgetSetting }[]>([]);

    protected columns = computed(() => {
        const showServiceInfo = [...new Set(this.items().map(x => x.serviceId))].length > 1;

        let cols = [
            folderPersonColumn,
            dateFromColumn,
            dateToColumn,
            {
                name: 'workData.swds.data',
                dataKey: 'workData.data',
                type: TableColumnType.String50,
            },
        ];

        if (showServiceInfo) {
            cols = [
                ...cols.slice(0, 1),
                serviceField('service', 'serviceId'),
                ...cols.slice(1),
            ];
        }

        return cols;
    });

    protected additionalFilters = computed<any>(() => {
        const filter = new FilterBuilder();
        filter
            .serviceIds(this.items().map(x => x.serviceId))
            .workType(WorkTypeEnum.SANCTION)
            .validByNow('dateFrom', 'dateTo')
        ;

        return filter.filter()?.filter || [];
    });

    protected readonly getWorksFrag = getWorksFrag;
}
